import { cust, pa } from "api/endpoints";
import { importView } from "../utils/misc";
const Calendar = importView("Calendar");
const BankList = importView("Bank/List");
const BranchList = importView("Branch/List");
const BranchForm = importView("Branch/Form");
const DocList = importView("Docs/List");
const DocForm = importView("Docs/Form");
const TemplateList = importView("Templates/List");
const TemplateForm = importView("Templates/Form");
const Conf = importView("Conf");
const BaConfig = importView("BaConfig");
const PointConf = importView("PointConf");
const News = importView("News");
const NewsForm = importView("News/Form");

const paRoutes = {
  path: "/",
  children: [
    {
      path: pa.cal,
      element: <Calendar />,
    },
    {
      path: pa.banks,
      element: <BankList />,
    },
    {
      path: pa.branches,
      element: <BranchList />,
    },
    {
      path: `${pa.branch}/:BrchId`,
      element: <BranchForm />,
    },
    {
      path: pa.docs,
      element: <DocList />,
    },
    {
      path: `${pa.doc}/:DocType`,
      element: <DocForm />,
    },
    {
      path: pa.templates,
      element: <TemplateList />,
    },
    {
      path: `${pa.template}/:TemplateId`,
      element: <TemplateForm />,
    },
    {
      path: pa.confs,
      element: <Conf />,
    },
    {
      path: "/admin/pa/ba/config",
      element: <BaConfig />,
    },
    {
      path: cust.pointConf,
      element: <PointConf />,
    }, // TODO later
    {
      path: pa.news,
      element: <News />,
    },
    {
      path: `${pa.news}/:NewsId`,
      element: <NewsForm />,
    },
  ],
};

export default paRoutes;
